export const signin = {
  pageLanding: 'page.signin.signinLandingPage',
  signinButtonClick: 'page.signin.login_attempt'
};
